import _get from "lodash/get";
import React, { useContext } from 'react';
import { rem } from 'polished';
import { Box } from '@rebass/grid';
import { ThemeContext } from 'styled-components';
import layoutTheme from '../../styles/layoutTheme';

var AsideWrapper = function AsideWrapper(_ref) {
  var order = _ref.order,
      children = _ref.children;
  var theme = useContext(ThemeContext);

  var gutter = _get(theme, 'layout.grid.gutter', layoutTheme.layout.grid.gutter);

  return /*#__PURE__*/React.createElement(Box, {
    px: gutter,
    width: [1, 1, 1, rem(_get(theme, 'layout.aside.width.md', layoutTheme.layout.aside.width.md))],
    flex: "0 0 auto",
    order: order
  }, children);
};

AsideWrapper.defaultProps = {
  order: 0,
  children: null
};
export default AsideWrapper;